'use client';

import { c as _c } from "react/compiler-runtime";
import { ListFilter } from '@repo/ui/icons';
import { DynamicIcon } from '@repo/ui/icons/dynamic';
import { cn } from '@repo/ui/lib/utils';
import { isIconName } from './saved-view-icon-picker.tsx';
export const SavedViewIcon = t0 => {
  const $ = _c(3);
  const {
    className,
    icon
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== icon) {
    t1 = icon && isIconName(icon) ? <DynamicIcon className={cn("size-4 shrink-0", className)} name={icon} /> : <ListFilter className={cn("size-4 shrink-0 text-muted-foreground", className)} />;
    $[0] = className;
    $[1] = icon;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};